module.exports = __webpack_public_path__ + "img/HY.1fdb2416.jpg";